const CERTIFIKATA_LABELS = {
    sq: {
        menu: 'Kontrollo vlefshmërinë e certifikatës',
        title: 'Kontrollo vlefshmërinë e certifikatës',
        intro: 'Plotësoni numrin unik identifikues dhe numrin serik për të kontrolluar vlefshmërinë e certifikatës.',
        nui: 'Numri unik identifikues',
        nuiPlaceholder: 'p.sh. 810000001',
        numerSerik: 'Numri serik',
        numerSerikPlaceholder: 'p.sh. 10000001',
        required: 'Kjo fushë është obligative',
        check: 'Kontrollo',
        cancel: 'Mbyll',
        checking: 'Po kontrollohet…',
        error: 'Ndodhi një gabim gjatë kontrollit. Provoni përsëri.',
        empty: 'Nuk u kthye asnjë mesazh nga serveri.',
        qrHint: 'Skanoni QR kodin me telefon ose klikoni butonin për të shkarkuar vërtetimin (PDF).',
        qrAlt: 'QR kodi për shkarkimin e vërtetimit',
        download: 'Shkarko vërtetimin (PDF)',
    },
    en: {
        menu: 'Check certificate validity',
        title: 'Check certificate validity',
        intro: 'Enter the unique identification number and the serial number to check the certificate validity.',
        nui: 'Unique identification number',
        nuiPlaceholder: 'e.g. 810000001',
        numerSerik: 'Serial number',
        numerSerikPlaceholder: 'e.g. 10000001',
        required: 'This field is required',
        check: 'Check',
        cancel: 'Close',
        checking: 'Checking…',
        error: 'An error occurred during the check. Please try again.',
        empty: 'The server returned no message.',
        qrHint: 'Scan the QR code with your phone or click the button to download the confirmation (PDF).',
        qrAlt: 'QR code to download the confirmation',
        download: 'Download confirmation (PDF)',
    },
    sr: {
        menu: 'Proveri valjanost sertifikata',
        title: 'Proveri valjanost sertifikata',
        intro: 'Unesite jedinstveni identifikacioni broj i serijski broj da biste proverili valjanost sertifikata.',
        nui: 'Jedinstveni identifikacioni broj',
        nuiPlaceholder: 'npr. 810000001',
        numerSerik: 'Serijski broj',
        numerSerikPlaceholder: 'npr. 10000001',
        required: 'Ovo polje je obavezno',
        check: 'Proveri',
        cancel: 'Zatvori',
        checking: 'Proverava se…',
        error: 'Došlo je do greške prilikom provere. Pokušajte ponovo.',
        empty: 'Server nije vratio nijednu poruku.',
        qrHint: 'Skenirajte QR kod telefonom ili kliknite dugme da preuzmete potvrdu (PDF).',
        qrAlt: 'QR kod za preuzimanje potvrde',
        download: 'Preuzmi potvrdu (PDF)',
    },
};

export default function getCertifikataLabels(locale) {
    return CERTIFIKATA_LABELS[locale] || CERTIFIKATA_LABELS.sq;
}
